var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseModalIcon = function SvgCloseModalIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 3.293a1 1 0 0 1 0 1.414L9.414 8l3.294 3.294a1 1 0 0 1 0 1.412v.001a1 1 0 0 1-1.415 0L8 9.414l-3.293 3.293a1 1 0 1 1-1.415-1.414L6.586 8 3.275 4.689a.974.974 0 0 1 0-1.378 1.025 1.025 0 0 1 1.45 0L8 6.586l3.293-3.293a1 1 0 0 1 1.414 0Z",
    fill: "#000"
  })));
};
export default SvgCloseModalIcon;